<template>
  <list-documents-results v-if="documents" :context="context" v-model="documents"
                          :nbEstimateDocument="nbEstimateDocument"
                          :nbDocuments="localAllDocuments.length"
                          :listType="listType"
                          :changeSort="changeSort"/>
</template>

<script>
import ListDocumentsResults from './ListDocumentsResults'
import Filters from './../filter/Filters'

export default {
  components: {
    Filters,
    ListDocumentsResults
  },
  props: ['allAuthors', 'type', 'listId', 'authorsSelected', 'authorsSimilar', 'context',
    'biblio', 'nbEstimateDocument', 'searchState', 'listType', 'searchType', 'project'],
  name: 'ListDocuments',
  data () {
    return {
      localAllDocuments: [],
      localAllAuthors: [],
      documents: [],
      sort: {
        col: 'pubDate',
        order: 'desc'
      }
    }
  },
  watch: {
    'context.pubDateSelected': function () {
      this.initDocuments()
    },
    'context.publicationsSelected': function () {
      this.initDocuments()
    },
    allAuthors: function (val) {
      this.localAllAuthors = val
    },
    localAllAuthors: function (val) {
      if (val.length !== 0) {
        this.getAllDocuments(val)
      }
    },
    localAllDocuments: function (val) {
      if (val.length !== 0 && this.listId !== null) {
        this.initDocuments()
      }
    },
    companyAuthorsSelected: function () {
      this.identifySelectedAndSimilarAuthors(this.documents)
    },
    'biblio.content': function (content) {
      this.setSelectedDocumentInBiblio()
    }
  },
  methods: {
    setSelectedDocumentInBiblio: function () {
      if (this.biblio !== null && typeof this.biblio.content !== 'undefined') {
        let content = JSON.parse(this.biblio.content)
        let documentsId = {}
        documentsId = this.getDocumentSelectedInBiblio(content)

        this.documents.forEach((document) => {
          document.biblio = documentsId[document.documentID] === true
        })

        this.documents = Object.assign([], this.documents)
      }
    },
    getDocumentSelectedInBiblio: function (nodes) {
      let documentsId = {}

      for (let keyNode in nodes) {
        if (!nodes.hasOwnProperty(keyNode)) { continue }
        if (typeof nodes[keyNode]['documents'] !== 'undefined') {
          for (let documentKey in nodes[keyNode]['documents']) {
            if (!nodes[keyNode]['documents'].hasOwnProperty(documentKey)) { continue }
            documentsId[nodes[keyNode]['documents'][documentKey]['id']] = true
          }
        }
      }
      return documentsId
    },
    getAllDocuments: function (authorsDocument) {
      let documents = {}
      let authors = {}

      let seDocumentTitle = [
        'Primary Domain',
        'Publications',
        'Training',
        'Influence',
        'Edison Since'
      ]

      authorsDocument.forEach((authorDocument) => {
        authorDocument.docs.forEach((document) => {
          if (seDocumentTitle.indexOf(document.title) === -1) {
            if (typeof documents[document.documentID] === 'undefined') {
              documents[document.documentID] = document
              documents[document.documentID].biblio = false
            }

            if (typeof documents[document.documentID].authorScore === 'undefined' || documents[document.documentID].authorScore < authorDocument.score) {
              documents[document.documentID].authorScore = authorDocument.score
            }
          }
        })

        authors[authorDocument.authorID] = authorDocument
      })

      let allDocuments = []
      for (let documentId in documents) {
        if (!documents.hasOwnProperty(documentId)) {
          continue
        }

        documents[documentId].co_authors = documents[documentId].co_authors.filter((author) => {
          if (typeof authors[author.authorID] !== 'undefined') {
            return authors[author.authorID]
          }
        })

        allDocuments.push(documents[documentId])
      }
      if (typeof this.searchType !== 'undefined' && this.searchType !== null && this.searchType.type === 'Name') {
        this.localAllDocuments = this.filterByName(allDocuments)
      } else {
        this.localAllDocuments = allDocuments
      }
    },
    initDocuments: function () {
      let documents = Object.assign([], this.localAllDocuments)

      if (this.context.pubDateSelected.length === 0 && this.context.publicationsSelected.length === 0) {
        this.context.filterSelected = null
      } else {
        if ((this.context.pubDateSelected.length === 0 && this.context.filterSelected === 'pubDate') ||
            (this.context.publicationsSelected.length === 0 && this.context.filterSelected === 'publication')) {
          this.context.filterSelected = null
          this.initFilters(documents)
        }

        if (this.context.filterSelected === null) {
          if (this.context.pubDateSelected.length > 0) {
            this.context.filterSelected = 'pubDate'
          }
          if (this.context.publicationsSelected.length > 0) {
            this.context.filterSelected = 'publication'
          }
        }
      }
      documents = this.applyFilters(documents)

      this.initFilters(documents)

      documents = this.applyFilters(documents)

      this.applySort(documents)

      this.identifySelectedAndSimilarAuthors(documents)
    },
    initFilters: function (documents) {
      let pubDateFilter = []
      let publicationFilter = []
      let countriesFilter = []
      let affiliationsFilter = []

      documents.forEach((document) => {
        let date = new Date(document.pubDate).getFullYear()

        let year = pubDateFilter.find((element) => {
          return element.name === date
        })

        if (typeof year === 'undefined') {
          pubDateFilter.push({nb: 1, name: date})
        } else {
          ++year.nb
        }

        let source = publicationFilter.find((element) => {
          return element.name === document.publication
        })

        if (typeof source === 'undefined') {
          publicationFilter.push({nb: 1, name: document.publication})
        } else {
          ++source.nb
        }

        document.co_authors.forEach((author) => {
          if (typeof author.affiliation !== 'undefined') {
            let country = countriesFilter.find((element) => {
              return element.name === author.affiliation.country
            })

            if (typeof country === 'undefined') {
              countriesFilter.push({nb: 1, name: author.affiliation.country})
            } else {
              ++country.nb
            }

            if (typeof affiliationsFilter[author.affiliation.organisationID] === 'undefined') {
              affiliationsFilter[author.affiliation.organisationID] = {
                nb: 1,
                name: author.affiliation.organisationName,
                id: author.affiliation.organisationID,
                country: author.affiliation.country
              }
            } else {
              ++affiliationsFilter[author.affiliation.organisationID].nb
            }
          }
        })
      })

      pubDateFilter.sort((date1, date2) => {
        return parseInt(date2.name) - parseInt(date1.name)
      })

      publicationFilter.sort((source1, source2) => {
        return parseInt(source2.nb) - parseInt(source1.nb)
      })

      if (this.context.filterSelected !== 'year' && this.context.pubDateSelected.length === 0) {
        this.context.pubDateFilter = pubDateFilter
      }

      if (this.context.filterSelected !== 'publication' && this.context.publicationsSelected.length === 0) {
        this.context.publicationFilter = publicationFilter
      }

      if (this.context.filterSelected === null) {
        this.context.pubDateFilter = pubDateFilter
        this.context.publicationFilter = publicationFilter
      }
      this.$emit('updatePubDate', pubDateFilter)
      this.$emit('updateCountries', {'countries': countriesFilter, 'companies': affiliationsFilter})
    },
    applyFilters: function (documents) {
      if (this.context.filterSelected !== null &&
          (this.context.pubDateSelected.length > 0 || this.context.publicationsSelected.length > 0)) {
        documents = documents.filter((document) => {
          let documentFilterByPublication = true
          let documentFilterByPubDate = true

          this.context.publicationsSelected.map((publication) => {
            if (document.publication === publication.name) {
              documentFilterByPublication = false
            }
          })

          this.context.pubDateSelected.map((year) => {
            let date = new Date(document.pubDate)
            if (date.getFullYear() === year.name) {
              documentFilterByPubDate = false
            }
          })

          let documentFilter = true
          if (documentFilterByPubDate === false || documentFilterByPublication === false) {
            documentFilter = false
            if (this.context.pubDateSelected.length > 0 && documentFilter === false) {
              documentFilter = documentFilterByPubDate
            }

            if (this.context.publicationsSelected.length > 0 && documentFilter === false) {
              documentFilter = documentFilterByPublication
            }
          }

          return !documentFilter
        })
      }
      return documents
    },
    applySort: function (documents) {
      switch (this.sort.col) {
        case 'pubDate':
          documents.sort((document1, document2) => {
            let date1 = new Date(document2.pubDate).getFullYear()
            let date2 = new Date(document1.pubDate).getFullYear()
            let score1 = document1.co_authors[0].score
            let score2 = document2.co_authors[0].score
            if (date1 === date2) {
              return score2 - score1
            }

            if (this.sort.order === 'desc') {
              return date1 - date2
            } else if (this.sort.order === 'asc') {
              return date2 - date1
            }
          })
          break
      }
    },
    identifySelectedAndSimilarAuthors: function (documents) {
      if (typeof this.authorsSelected !== 'undefined' && this.authorsSelected !== null &&
          typeof this.authorsSimilar !== 'undefined' && this.authorsSimilar !== null) {
        documents.forEach((document) => {
          document.co_authors.forEach((author) => {
            author.selected = false
            author.similar = false
            this.authorsSelected.forEach((authorSelected) => {
              if (authorSelected.authorID === author.authorID) {
                author.selected = true
              }
            })

            this.authorsSimilar.forEach((authorSimilar) => {
              if (authorSimilar.authorID === author.authorID) {
                author.similar = true
              }
            })
          })
        })
      }

      this.documents = documents

      this.setSelectedDocumentInBiblio()
    },
    filterByName: function (documents) {
      documents = documents.filter((document) => {
        let foundAuthor = document.co_authors.find((author) => {
          return author.lastName.toLowerCase() === this.searchType.lastName.toLowerCase()
        })
        return typeof foundAuthor !== 'undefined'
      })
      return documents
    },
    changeSort: function (col) {
      this.sort.col = col
      this.sort.order = (this.sort.order === 'desc' ? 'asc' : 'desc')
      this.applySort(this.documents)
    }
  },
  beforeMount () {
    this.localAllAuthors = this.allAuthors
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListDocuments/ListDocuments.vue